import { workerService } from 'js/services/worker.service';

import { TJackpots, IJackpot, IGetCasinoJackpotsParams } from './types';

export const getJackpots = (
    { jackpotsCasinoUrl, jackpotsCasino, currencyCode }: IGetCasinoJackpotsParams
): Promise<{ jackpots: TJackpots; casinoJackpot: IJackpot }> => workerService.request('jackpot', {
    currencyCode,
    url: `${jackpotsCasinoUrl}?casino=${jackpotsCasino}&currency=${currencyCode}&includeCasinoTotal=true`
});
